export const REPAYMENT_PERIOD_OPTIONS = [
  6, 12, 18, 24, 30, 36, 48, 60, 72, 84, 96,
];
